import { render, staticRenderFns } from "./FemToolsPage.vue?vue&type=template&id=4d6980c6&scoped=true&"
import script from "./FemToolsPage.vue?vue&type=script&lang=js&"
export * from "./FemToolsPage.vue?vue&type=script&lang=js&"
import style0 from "./FemToolsPage.vue?vue&type=style&index=0&id=4d6980c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6980c6",
  null
  
)

export default component.exports